var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-pay__success"},[_c('i',{staticClass:"z-img-success"}),_vm._v(" "),_c('h2',[_vm._v("支付成功")]),_vm._v(" "),_c('p',[_vm._v("您已成功开通小站会员")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }